import React, { ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { antdTheme, GlobalStyle } from '../../shared/styles/antd-theme';
import { MessageDisplayer } from '../../shared/components/MessageDisplayer';
import { GlobalsProvider } from '../../shared/contexts/GlobalsContext';

import { GlobalsTools } from '@shared/types';
import { ThemeProvider } from './ThemeProvider';
import type { AppState } from '../../declarations/redux';

interface AppProvidersProps {
  store: Store<AppState>;
  tools: GlobalsTools;
  children: ReactNode;
}

export function AppProviders({ store, tools, children }: AppProvidersProps) {
  const { queryClient } = tools;

  return (
    <GlobalsProvider tools={tools}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <ConfigProvider prefixCls="ant-v5" theme={antdTheme}>
              <GlobalStyle />
              <MessageDisplayer />
              {children}
            </ConfigProvider>
          </ThemeProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </GlobalsProvider>
  );
}
